module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button-social",
    class: _vm.buttonSocialDesignObject,
    attrs: {
      "page-url": _vm.page_url,
      "page-title": _vm.page_title,
      "page-description": _vm.page_description,
      "button-design": _vm.button_design,
      "title-social": _vm.title_social,
      "has-icon": _vm.has_icon,
      "has-square-edges": _vm.has_square_edges,
      "has-counter": _vm.has_counter
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showShareWindow($event)
      }
    }
  }, [(this.$props.has_icon) ? _c('i', {
    staticClass: "icon-linkedin"
  }) : _vm._e(), _vm._v(" "), (this.$props.title_social) ? _c('span', {
    staticClass: "title-social"
  }, [_vm._v(_vm._s(_vm.title_social))]) : _vm._e(), _vm._v(" "), (this.$props.has_counter) ? _c('span', {
    staticClass: "counter-linkedin",
    model: {
      value: (_vm.counter_linkedin),
      callback: function($$v) {
        _vm.counter_linkedin = $$v
      },
      expression: "counter_linkedin"
    }
  }, [_vm._v(_vm._s(_vm.counter_linkedin))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1516acb8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-goodshare/src/providers/LinkedIn.vue
// module id = 1167
// module chunks = 14